export default "__VITE_ASSET__Bw_Upz9x__"